<template>

      <v-col class="white lighten-5 mb-10 py-0" cols="12">
        <v-col
          class="white lighten-5 mb-5 py-0 col-md-10 offset-md-1 col-12 offset-0"
        >
          <div class="white lighten-5" style="height: 70px"></div>
          <h2
            class="white lighten-5 headline font-weight-bold mb-3 other-element2"
            style="letter-spacing: 0.13125em !important; color: #616161"
          >
            АКЦИИ МИЛОСЕРДИЯ
          </h2>
          <v-divider
            class="grey darken-2 mx-auto"
            light
            style="min-height: 3px; max-width: 50px"
          ></v-divider>
          <!-- <transition name="fade"> -->



          <v-row class="pt-10 pb-xs-1">
            <v-col
              class="pt-10 px-lg-3 col-sm-4 offset-sm-1 col-md-6 offset-md-0 col-lg-3 col-12"
              v-for="(item, m) in news"
              :key="m"
              data-aos="flip-left"
              data-aos-offset="100"
              data-aos-delay="50" 
              data-aos-duration="2000"
              data-aos-easing="ease-out-back"
              data-aos-mirror="true"
              data-aos-once="false"
              data-aos-anchor-placement="center-bottom"
            >
            <!-- data-aos-delay="50" -->
             <!-- :data-aos-delay="delayFunction()" -->
              <!-- <v-lazy
                v-model="isActive"
                :options="{ threshold: 0.5 }"
                transition="fade-transition"
              > -->
               <!-- <v-hover v-slot="{ hover }"> -->
                  <v-card 
                    class="mx-auto mb-1" 
                    max-width="400" 
                    min-height="300" 
                    elevation="6"
                    shaped
                    :to="'mercy'"
                  >
                  
                    <v-img 
                      contain
                      aspect-ratio="1.1"
                      class="mx-1" 
                      :style="'background-image: url('+item.mainImg+'); background-position: center center; background-size: cover;'"
                    ></v-img>
                    <v-card-title class="justify-center">
                      <v-row no-gutters>
                        <v-col cols="12" >
                          <span class="textWordBreak text-uppercase newsNamesTextMainPage">{{ item.newsTitle }}</span>
                        </v-col>
                      </v-row>
                    </v-card-title>

                    <!-- <v-expand-transition  >
                      <div
                        v-if="hover"
                        class="d-flex transition-fast-in-fast-out blue-grey lighten-2 v-card--reveal display-1 white--text "
                        style="height: 100%; opacity: 85%"
                      >
                        {{ item.newsTitle }}
                      </div>
                    </v-expand-transition> -->
                    
                  </v-card>
                <!-- </v-hover> -->
              <!-- </v-lazy> -->
            </v-col>
          </v-row>
          
         


          <v-row justify="center">
            <div class="justify-center align-center text-center mb-5 mt-16">
              <v-btn
                class="btnStyle"
                rounded
                color="orange"
                dark
                large
                elevation="6"
                @click="goTo('mercy')"
                data-aos="fade-up"
                data-aos-offset="100"
                data-aos-delay="10"
                data-aos-duration="1500"
                data-aos-easing="ease-out-back"
                data-aos-once="false"
                data-aos-anchor-placement="top-bottom"
              >
                <v-icon class="ml-2 mr-5 white--text" size="30"
                  >mdi-heart-outline</v-icon
                >СМОТРЕТЬ<v-icon class="ml-5 mr-2 white--text" size="30"
                  >mdi-heart-multiple-outline</v-icon
                >
              </v-btn>
            </div>
          </v-row>
        </v-col>
      </v-col>

</template>



<script>
export default {
  name: "SectionFifth",
  data() {
    return {
      isActive: false,
      delayVal: 1,
    };
  },

    computed: {
    news() {
      return this.$store.getters.getNewsMainPage;
    },
  },

  methods: {
    goTo(value) {
      this.$router.push(value).catch(() => {});
    },



    delayFunction() {
      let delayValue = 1;
      try {
        
          if (this.delayVal == 1) {
            delayValue = 1;
            this.delayVal = 150;
            this.count = 1;
          } else if (this.delayVal == 150) {
            delayValue = 150;
            this.delayVal = 300;
            this.count = 2;
          } else if (this.delayVal == 300) {
            delayValue = 300;
            this.delayVal = 450;
            this.count = 3;
          } else if (this.delayVal == 450) {
            delayValue = 450;
            // this.delayVal = 1;
           
          }
          
      
        // console.log(delayValue);
        console.log(delayValue);
        return delayValue;
       
      } catch (error) {
        console.log(error);
      }
    }

  },



};
</script>

<style scoped>
/* отображение текста в карточке не шире 3-х строк + ... */
.newsNamesTextMainPage {
  height: calc(
    24px * 2
  ); /* не стал писать 75px, чтобы показать, что максимум по высоте на 3 строки выделяю блок */
  padding-top: 5px;
  /* margin-bottom: 10px; */
  overflow: hidden;
  line-height: 22px; /* каждая строка будет по высоте 25px, чтобы я точно мог установить высоту блока (это чисто визуально, ни на что не влияет) */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

</style>
